export function trimStart(string: string, char: string) {
  if (!string) {
    return '';
  }
  let i = 0;
  while (string[i] === char) {
    i++;
  }
  return string.substr(i);
}

export function trimEnd(string: string, char: string) {
  if (!string) {
    return '';
  }
  let i = string.length;
  while (string[i - 1] === char) {
    i--;
  }
  return string.substr(0, i);
}
